








































import { Vue, Component, State, namespace, Watch, Prop } from 'nuxt-property-decorator'
import throttle from 'lodash/throttle'
import { Experience } from '~/types/experience'
import CategoryTree from '~/components/experience/destinations-category-tree/category-tree.vue'
import RangesTree from '~/components/experience/destinations-category-tree/ranges-tree.vue'

import TreeNode = Experience.TreeNode
import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component({
  components: {
    CategoryTree, RangesTree
  }
})

export default class ModalTree extends Vue {
  @State klook!: Data.Klook
  @experience.State categoryTreeData!: TreeNode[]
  @experience.State rangeData!: TreeNode[]
  @experience.State urlQuery!: UrlQuery
  @experience.Action setUrlQuery!: Function
  @experience.Action setSelectedCategory!: Function
  @experience.Action setSelectedRanges!: Function
  @Prop() type!: 'range' | 'category'
  keyword: string = ''
  ranges: TreeNode[] = []
  category: TreeNode[] = []
  searchResult: TreeNode[] = []
  throttleSearch: Function = throttle(this.search, 500)
  selectedRange: any = []
  selectedCategory: any = []

  get expandAll() {
    return this.klook.platform === 'desktop'
  }

  get placeholder() {
    const rangePlaceholder = this.$t('index.citylist.city')
    const categoryPlaceholder = this.$t('15620')
    return this.type === 'range' ? this.$t('5301', rangePlaceholder) : this.$t('5301', categoryPlaceholder)
  }

  @Watch('keyword')
  keywordChange() {
    if (this.keyword === '') {
      this.initData()
      this.ranges = JSON.parse(JSON.stringify(this.ranges))
      this.category = JSON.parse(JSON.stringify(this.category))
    } else {
      this.throttleSearch()
    }
  }

  search(data?: TreeNode[]) {
    const treeData = this.type === 'range' ? this.ranges : this.category
    const d = data || treeData
    const keyword = this.keyword.replace(/ +/g, '').toLocaleLowerCase()

    d.forEach((item1: TreeNode) => {
      if (this.matchWord(item1.title, keyword)) {
        item1.show = true
      } else {
        item1.show = false
      }
      item1.children && item1.children.forEach((item2: TreeNode) => {
        if (this.matchWord(item2.title, keyword)) {
          item2.show = true
          item1.show = true
        } else {
          item2.show = false
        }
        item2.children && item2.children.forEach((item3: TreeNode) => {
          if (this.matchWord(item3.title, keyword)) {
            item3.show = true
            item2.show = true
            item1.show = true
          } else {
            item3.show = false
          }
          item1.expand = true
          item2.expand = true
          item3.expand = true
        })
      })
    })
    this.ranges = JSON.parse(JSON.stringify(this.ranges))
    this.category = JSON.parse(JSON.stringify(this.category))
  }

  matchWord(sourceWord: string, keyword: string) {
    const source = sourceWord.replace(/ +/g, '').toLocaleLowerCase()
    return source.includes(keyword)
  }

  initData(data?: TreeNode[]) {
    const treeData = this.type === 'range' ? this.ranges : this.category
    const d = data || treeData
    d.forEach((item: TreeNode) => {
      item.show = true
      item.expand = this.klook.platform === 'desktop'
      item.children && this.initData(item.children)
    })
  }

  rangeChange(data: any) {
    this.selectedRange = data.selected
    const country = Object.keys(this.selectedRange.countryId || []).join(',')
    const city = Object.keys(this.selectedRange.cityId || []).join(',')
    const confirm = document.querySelector('.js-tree-modal-confirm') as HTMLElement
    this.$inhouse.updateBinding(confirm, {
      ext: JSON.stringify({
        country_id: country,
        city_id: city
      })
    })
    this.$emit('rangeChange', this.selectedRange)
  }

  categoryChange(data: any) {
    this.selectedCategory = data.selected
    const category = Object.keys(this.selectedCategory || []).join(',')
    const confirm = document.querySelector('.js-tree-modal-confirm') as HTMLElement
    this.$inhouse.updateBinding(confirm, {
      ext: JSON.stringify({ categorytree_id: category })
    })
    this.$emit('categoryChange', this.selectedCategory)
  }

  clearAll(data?: TreeNode[]) {
    const treeData = this.type === 'range' ? this.ranges : this.category
    const d = data || treeData
    d.forEach((item: TreeNode) => {
      item.show = true
      item.checked = false
      item.expand = false
      item.children && this.clearAll(item.children)
    })
  }

  parentClearAll() {
    this.clearAll()
    this.ranges = JSON.parse(JSON.stringify(this.ranges))
    this.category = JSON.parse(JSON.stringify(this.category))
  }

  mounted() {
    this.ranges = JSON.parse(JSON.stringify((this.rangeData)))
    this.category = JSON.parse(JSON.stringify((this.categoryTreeData)))
  }
}
